import { render, staticRenderFns } from "./AdminModuleMenu.vue?vue&type=template&id=7da54306"
import script from "./AdminModuleMenu.vue?vue&type=script&lang=js"
export * from "./AdminModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports